import { useEffect, useState } from 'react';
import { scheduleDate } from './scheduleDates';

export function useScheduleDate() {
  const [today, setToday] = useState(scheduleDate);
  useEffect(() => {
    const tick = () => setToday(scheduleDate());
    const timer = window.setInterval(tick, 10000);
    window.addEventListener('focus', tick);
    document.addEventListener('visibilitychange', tick);
    return () => { clearInterval(timer); window.removeEventListener('focus', tick); document.removeEventListener('visibilitychange', tick); };
  }, []);
  return today;
}
